import { Box } from '@chakra-ui/react';

import { TextBold, TextMedium } from 'UiKit/typography';
import formatCurrency from 'Helper/formatCurrency';

import styles from './styles.module.css';

const ColumnPriceDetail = ({ data }) => {
  return (
    <Box className={styles['column-price-detail__container']}>
      <Box>
        <TextBold className={styles['column-price-detail__text--promotion']}>{data?.promotionPrice ? formatCurrency(data?.promotionPrice) : '-'}</TextBold>
      </Box>
      <Box className={styles['column-price-detail__subcontainer']}>
        <TextMedium className={styles['column-price-detail__text--normal']}>{data?.normalPrice ? formatCurrency(data?.normalPrice) : '-'}</TextMedium>
        <TextMedium className={styles['column-price-detail__text--discount']}>{data?.discountPercentage ? `${data?.discountPercentage}%` : '-'}</TextMedium>
      </Box>
    </Box>
  );
};

export default ColumnPriceDetail;
